import { PRESET_CUSTOM_1_TEMPLATE, PRESET_CUSTOM_1_STYLESHEET, } from './presetBundles.generated';
/** Bundled COU markup keyed by `preset` / `settings.custom_layout_preset`. */
export const CUSTOM_LAYOUT_PRESETS = {
    'custom-1': {
        template: PRESET_CUSTOM_1_TEMPLATE,
        stylesheet: PRESET_CUSTOM_1_STYLESHEET,
    },
};
/** Stable list for logs / publisher tooling (deduped display names). */
export function listBundledCustomLayoutPresetIds() {
    return [...new Set(Object.keys(CUSTOM_LAYOUT_PRESETS))].sort();
}
